import { render, staticRenderFns } from "./CompContact.vue?vue&type=template&id=c4be6eaa&scoped=true"
import script from "./CompContact.vue?vue&type=script&lang=js"
export * from "./CompContact.vue?vue&type=script&lang=js"
import style0 from "./CompContact.vue?vue&type=style&index=0&id=c4be6eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4be6eaa",
  null
  
)

export default component.exports